module.exports = __webpack_public_path__ + "static/media/20ECE10.7b2214a4.jpg";